import Swiper, {Pagination, FreeMode, Grid, Autoplay} from 'swiper';
import 'swiper/css';
import 'swiper/scss/scrollbar'
import 'swiper/scss/pagination'

import jQuery from 'jquery';
import "jquery-validation"
import "jquery-validation/dist/additional-methods"
import flatpickr from "flatpickr";
import LightBoxVideo from "../modules/LightBoxVideo";
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger,ScrollSmoother);

const scroller=ScrollSmoother.create({
	smooth: 1,             // how long (in seconds) it takes to "catch up" to the native scroll position
	effects: true,           // looks for data-speed and data-lag attributes on elements
	smoothTouch: 0.1,        // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
});

import Navbar from '../modules/Navbar'
const navbar=new Navbar();

// export for others scripts to use
window.$ = jQuery;
window.jQuery = jQuery;

const messagePlace = document.querySelector('.js-message-place-holder');
const messagePlaceClass = '.js-message-place'
const handleResult = (result) => {
    messagePlace.classList.add('show')
    messagePlace.classList.remove('error')
    if (result.success) {
        $(messagePlaceClass).html(result.data)
    } else {
        messagePlace.classList.add('error')
        $(messagePlaceClass).html('')
        result.data.forEach(err => {
            $(messagePlaceClass).append(`<p>${err.message}</p>`)
        })
    }
}

const filePlaceholder = "ファイルがまだ選択されていません";

gsap.utils.toArray(".image-parallax").forEach(function(container) {
    let image = container.querySelector("img");
    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: container,
            scrub: true,
            pin: false,
            //markers:true
        },
    });
    tl.from(image, {
        yPercent: -30,
        ease: "none",
    }).to(image, {
        yPercent: 30,
        ease: "none",
    });
});

const scrollToBottom=document.querySelector('.banner__scroll-buttom');
const scrollToBottomTarget=document.querySelector('.ourbusiness-two');

if (scrollToBottom && scrollToBottomTarget) {
    scrollToBottom.addEventListener("click", function(e){
        e.preventDefault();
        navbar.scrollToSection(scrollToBottomTarget);
    })
}

window.addEventListener("DOMContentLoaded", () => {
    const videoPlay = document.querySelector('.js-recruit-video')
    const lightBoxVideo = new LightBoxVideo(videoPlay)
    const swiperSelector = '.swiper'

    if (document.querySelector(swiperSelector))
        new Swiper(swiperSelector, {
            slidesPerView: "auto",
            grid: 1,
            spaceBetween: 30,
            freeMode: true,
            autoplay: {
                delay: 3000,
            },
            modules: [Pagination, FreeMode, Grid, Autoplay],
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },

        });

    const errorClass = 'recruit__error'
    const fileFields = document.querySelectorAll(".js-file-field");

    if (fileFields) {
        fileFields.forEach(item => {
            item.addEventListener('change', event => {
                if (event.target.files[0].name) {
                    item.nextElementSibling.innerHTML = event.target.files[0].name
                }
            })
        })
    }

    flatpickr("#dob", {
        dateFormat: "Y/m/d",
        maxDate: new Date()
    });

    jQuery("#recruitForm").validate({
        errorClass: errorClass,
        rules: {
            name: {
                required: true
            },
            dob: {
                required: true
            },
            email: {
                required: true,
                email: true
            },
            phone: {
                required: true,
            },
            agree: {
                required: true,
            },
            portfolio: {
                required: false,
                accept: "image/*, application/pdf, application/doc, application/docx"
            },
            resume: {
                required: true,
                accept: "image/*, application/pdf, application/doc, application/docx",
            },
            curriculum_vitae: {
                required: false,
                accept: "image/*, application/pdf, application/doc, application/docx",
            },
        },
        errorPlacement: function (error, element) {
            switch (true) {
                case element.attr('type') === 'file':
                    error.appendTo(element.parents('.recruit__form__field__file').next('.file_error'))
                    break;
                case element.attr('name') === 'agree':
                    error.appendTo(element.parents('.agree-parent'))
                    break;
                default:
                    error.appendTo(element.parent());
            }
        },
        messages: {
            name: "お名前を入力してください。",
            dob: "生年月日を入力してください。",
            email: "有効なメールアドレスを入力してください。",
            phone: "有効な電話番号を入力して下さい。",
            resume: "履歴書をアップロードしてください。",
            agree: "このフィールドは必須です。"
        },
        submitHandler: function (form) {
            messagePlace.classList.remove('show')
            const formData = new FormData(form);
            $('.js-loading').addClass('active')
            $.ajax({
                url: admin_ajax.url,
                type: "POST",
                data: formData,
                contentType: false,
                processData: false,
                beforeSend: function () {
                    messagePlace.classList.remove('show')
                    $(window).scrollTop(0);
                },
                success: function (response) {
                    handleResult(response)
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    console.log(errorThrown);
                },
                complete: function () {
                    form.reset()
                    if (fileFields) {
                        fileFields.forEach(item => {
                            item.nextElementSibling.innerHTML = filePlaceholder
                        })
                    }
                    $('.js-loading').removeClass('active')
                }
            });
        }
    });
})

const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
});
let value = params.section; // "some_value"

window.addEventListener("load", (event) => {
    if(value=='work-environment-link'){
        navbar.scrollToSection('#work-environment')
        }else if(value=='mid-career'){
        navbar.scrollToSection('#mid-career')
    }
});


